enum ActionTypes {
  GET_MMV_DATA_REQUEST = "GET_MMV_DATA_REQUEST",
  GET_MMV_DATA_SUCCESS = "GET_MMV_DATA_SUCCESS",
  GET_MMV_DATA_FAILURE = "GET_MMV_DATA_FAILURE"
}

export default ActionTypes;
